/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Order_Carrier_Mark_Ready_To_Deliver_SuccessInputs */

const vi_toast_order_carrier_mark_ready_to_deliver_success = /** @type {(inputs: Toast_Order_Carrier_Mark_Ready_To_Deliver_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã đánh dấu bàn giao cho bên vận chuyển`)
};

/**

* @param {Toast_Order_Carrier_Mark_Ready_To_Deliver_SuccessInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const toast_order_carrier_mark_ready_to_deliver_success = /** @type {((inputs?: Toast_Order_Carrier_Mark_Ready_To_Deliver_SuccessInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Order_Carrier_Mark_Ready_To_Deliver_SuccessInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_toast_order_carrier_mark_ready_to_deliver_success(inputs)
});